import React from 'react';

import {
  StyledCigarette,
  StyledCigaretteContainer,
} from '../../../pages/Constructor/CigaretteConstructor';

import { useTracker } from '../../../context/constructorContext';
import type { SearchType } from '@lt/api/dist/types/searchParams';
import type { InitialValues, Values } from '../../../components/Cigarette/context';
import { MIN_DESKTOP_CIGARETTE_WIDTH } from '../../constants';

interface IEmbeddedCigarette {
  containerWidth: number;
  domain: string;
  searchType: SearchType;
  initialValues: InitialValues;
  hasMargins?: boolean;
  onChange?: (values: Values) => void;
  enableDestination?: boolean;
}

export const EmbeddedCigarette = (props: IEmbeddedCigarette): JSX.Element => {
  const {
    domain,
    searchType,
    initialValues,
    hasMargins = false,
    enableDestination = false,
    onChange,
    containerWidth,
  } = props;
  const isMobile = containerWidth < MIN_DESKTOP_CIGARETTE_WIDTH;
  const trackerMethods = useTracker();

  const handleChange = (values: Values, changes: Values) => {
    if (onChange) {
      onChange(values);
    }

    if (!trackerMethods) {
      return;
    }

    const { trackSearchParamsChange } = trackerMethods;
    trackSearchParamsChange(changes, values);
  };

  return (
    <StyledCigaretteContainer $color={'#F3F2E8'} $isMobile={isMobile} $hasMargins={hasMargins}>
      <StyledCigarette
        searchType={searchType}
        $withoutButton
        mobileVariant={isMobile ? 'default' : undefined}
        $isMobile={isMobile}
        host={domain}
        variant={enableDestination ? 'default' : 'hotel'}
        initialValues={initialValues}
        onChange={handleChange}
        $width={containerWidth - (hasMargins ? 32 : 16)}
        isWidget
      />
    </StyledCigaretteContainer>
  );
};
